import ButtonTypes from './buttonTypes';

const coOrderAssemblyType = {
  ASSEMBLY: 'Assembly',
  SENDING: 'Sending',
  SERVICE: 'Service',
  OVERSTOCK: 'Overstock',
  REASSEMBLY: 'Reassembly',
  ORDER_ISSUE: 'Order issue',
};

export const coOrderStatusInfo = {
  [coOrderAssemblyType.ASSEMBLY]: {
    title: 'Assembly',
    state: ButtonTypes.WARNING
  },
  [coOrderAssemblyType.SENDING]: {
    title: 'Sending',
    state: ButtonTypes.LIGHT_SUCCESS
  },
  [coOrderAssemblyType.SERVICE]: {
    title: 'Service',
    state: ButtonTypes.LIGHT_DANGER
  },
  [coOrderAssemblyType.OVERSTOCK]: {
    title: 'Overstock',
    state: ButtonTypes.LIGHT_DANGER
  },
  [coOrderAssemblyType.REASSEMBLY]: {
    title: 'Reassembly',
    state: ButtonTypes.LIGHT_DANGER
  },
  [coOrderAssemblyType.ORDER_ISSUE]: {
    title: 'Order issue',
    state: ButtonTypes.DANGER
  },

};

export const coOrderAssemblyTypeList = [
  { label: coOrderAssemblyType.ASSEMBLY, value: coOrderAssemblyType.ASSEMBLY },
  { label: coOrderAssemblyType.SENDING, value: coOrderAssemblyType.SENDING },
  { label: coOrderAssemblyType.OVERSTOCK, value: coOrderAssemblyType.OVERSTOCK },
  { label: coOrderAssemblyType.ORDER_ISSUE, value: coOrderAssemblyType.ORDER_ISSUE },
];

export const coOrderAssemblyStyleList = [
  { label: coOrderAssemblyType.SERVICE, value: coOrderAssemblyType.SERVICE },
  { label: coOrderAssemblyType.REASSEMBLY, value: coOrderAssemblyType.REASSEMBLY },
];

export default coOrderAssemblyType;
